import Cookies from 'universal-cookie';
import { v4 as uuidv4 } from 'uuid';
import isbot from 'isbot';
import { QH_USER_ID_COOKIE } from '../../config/constants';

const { NAME: COOKIE_NAME, PATH: COOKIE_PATH, MAX_AGE: COOKIE_MAX_AGE, CRAWLER_USER_ID } = QH_USER_ID_COOKIE;

const isCrawler = (userAgent?: string) => userAgent && isbot(userAgent);

const generateUserId = () => (isCrawler(navigator.userAgent) ? CRAWLER_USER_ID : uuidv4());

const findOrCreateQhUserId = () => {
  const cookies = new Cookies();

  const qhUserId = cookies.get(COOKIE_NAME) || generateUserId();

  cookies.set(COOKIE_NAME, qhUserId, {
    path: COOKIE_PATH,
    maxAge: COOKIE_MAX_AGE,
    sameSite: 'strict',
  });

  return qhUserId;
};

export default findOrCreateQhUserId;
